import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { RULE_PREVIEWS } from '../actions';

const initialState = [];

const rulePreviewsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case RULE_PREVIEWS.GET_RULE_PREVIEWS:
        return payload;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default rulePreviewsReducer;
